export default class LinksGenerator {
    // Public:
    compute(nodes) {
        this.links = [];
        this.createLinks(nodes);
        this.numberLinks();
        return this.links;
    }

    // Private:
    createLinks(nodes) {
        nodes.forEach(node => {
            const itIsSlave = node.type === "slave";
            if (itIsSlave) {
                let ownersIds = node.ownersIds;
                let groups = node.group;
                for (let index = 0; index < ownersIds.length; index++) {
                    const ownerId = ownersIds[index];
                    const group = groups[index];
                    const nodeId = node.id;
                    let link = {
                        sourceId: ownerId,
                        targetId: nodeId,
                        group: group,
                        number: index,
                    };
                    this.links.push(link);
                }
            }
        });
    }

    numberLinks() {
        let links = this.links;
        for (let i = 0; i < links.length; i++) {
            const node = links[i];
            node.number = i;
        }
        this.links = links;
    }
}
